export default __webpack_public_path__ + "static/char-v-sp03-59a36f2e55be091fb3a73d1bfc74a518.webp";